import React, { useState, useEffect } from "react";
import { Tabs, Input, Button } from "antd";
import NetworkService from "../../services/NetworkService";
import { useAtom } from "jotai";
import { energyTableView } from "../../assets/tableViews";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { accessTokenAtom } from "../../atoms";
import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
  Label,
  ResponsiveContainer,
} from "recharts";
import { useMsal, useAccount } from "@azure/msal-react";
import { graphrequest, loginRequest } from "../../authConfig";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function Dashboard() {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [currentTabTitle, setCurrentTabTitle] = useState("CC Chart");
  const [loading, setLoading] = useState(false);
  const [residentialPlans, setResidentialPlans] = useState([]);
  const [ccDashboardData, setCCDashboardData] = useState([]);
  const [recDashboardData, setRECDashboardData] = useState([]);
  const [sgrecDashboardData, setSGRECDashboardData] = useState([]);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState();

  useEffect(() => {
    async function getData() {
      if (account) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: account,
          })
          .then((response) => {
            console.log("CH", response);

            setAccessToken(response.accessToken);
            return response.accessToken;
          })
          .then((token) => {
            const networkServiceObj = new NetworkService();
            networkServiceObj.getDashboard(token).then((res) => {
              const ccDashboard = [];
              const recDashboard = [];
              const sgRecDashboard = [];

              const moveKeys = (source, destination, keyword) => {
                source.forEach((obj) => {
                  const newObj = {};
                  Object.keys(obj).forEach((key) => {
                    if (key.includes(keyword) || key.includes(keyword.toLowerCase())) {
                      newObj[key] = obj[key];
                      delete obj[key];
                    }
                    newObj["reportingMonth"] = obj["reportingMonth"];
                    newObj["reportingYear"] = obj["reportingYear"];
                    newObj["reportingMonthNumeric"] = obj["reportingMonthNumeric"];
                    newObj["xAxis"] =
                      `${obj["reportingMonth"]}-'${obj["reportingYear"].toString().slice(-2)}`;
                  });
                  destination.push(newObj);
                });
              };

              // moveKeys(res.data, adhocDashboard,"adhoc");
              moveKeys(res.data, sgRecDashboard, "SGREC");
              moveKeys(res.data, recDashboard, "REC");
              moveKeys(res.data, ccDashboard, "CC");

              setCCDashboardData(ccDashboard);
              setRECDashboardData(recDashboard);
              setSGRECDashboardData(sgRecDashboard);

              console.log("CC", ccDashboard);
              console.log("REC", recDashboard);
              console.log("SGREC", sgRecDashboard);
            });
          });
      }
    }

    getData();
  }, []);

  const handleTabChange = (key) => {
    const currentTab = secondTab.find((t) => t.key === key);
    if (!currentTab) return;
    const tabLabel = currentTab.label;
    setCurrentTabTitle(tabLabel);
  };

  const CCDashboard = () => {
    return (
      <ResponsiveContainer aspect={2}>
        <BarChart
          margin={{ top: 15, left: 30 }}
          data={ccDashboardData.sort((a, b) => {
            if (a.reportingYear !== b.reportingYear) {
              return a.reportingYear - b.reportingYear;
            } else {
              return a.reportingMonthNumeric - b.reportingMonthNumeric;
            }
          })}
        >
          <Tooltip formatter={(value) => new Intl.NumberFormat("en").format(value)} />
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={"xAxis"}>
            {/* <Label value={"XXX"} layout="horizontal" verticalAlign="top" align="center" height={25} position="insideBottom" offset={-50}/> */}
          </XAxis>
          <YAxis
            width={80}
            tickFormatter={(tick) => {
              return tick.toLocaleString();
            }}
          >
            <Label value={"kgCO2e"} align="center" position="insideLeft" offset={-20} angle={-90} />
          </YAxis>
          <Tooltip />
          <Legend style={{ marginBottom: 50 }} />
          <Bar dataKey="ccAvailableQuantity" name="Active CC" fill="#8884d8" />
          <Bar dataKey="retiredCnIForCC" name="Retired CC for C&I" fill="#82ca9d" />
          <Bar dataKey="retiredResidentialForCC" name="Retired CC for Residential" fill="green" />
          <Bar dataKey="adhocforCC" name="Ad-hoc CC" fill="blue" />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const RECDashboard = () => {
    return (
      <ResponsiveContainer aspect={2}>
        <BarChart
          margin={{ top: 15, left: 30 }}
          data={recDashboardData.sort((a, b) => {
            if (a.reportingYear !== b.reportingYear) {
              return a.reportingYear - b.reportingYear;
            } else {
              return a.reportingMonthNumeric - b.reportingMonthNumeric;
            }
          })}
        >
          <Tooltip formatter={(value) => new Intl.NumberFormat("en").format(value)} />
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={"xAxis"}>
            {/* <Label value={"XXX"} layout="horizontal" verticalAlign="top" align="center" height={25} position="insideBottom" offset={-50}/> */}
          </XAxis>
          <YAxis
            width={80}
            tickFormatter={(tick) => {
              return tick.toLocaleString();
            }}
          >
            <Label value={"kWh"} align="center" position="insideLeft" offset={-20} angle={-90} />
          </YAxis>
          <Tooltip />
          <Legend style={{ marginBottom: 50 }} />
          <Bar dataKey="recAvailableQuantity" name="Active REC" fill="#8884d8" />
          <Bar dataKey="retiredCnIForREC" name="Retired REC for C&I" fill="#82ca9d" />
          <Bar dataKey="retiredResidentialForREC" name="Retired REC for Residential" fill="green" />
          <Bar dataKey="adhocforREC" name="Ad-hoc REC" fill="blue" />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const SGRECDashboard = () => {
    return (
      <ResponsiveContainer aspect={2}>
        <BarChart
          margin={{ top: 15, left: 30 }}
          data={sgrecDashboardData.sort((a, b) => {
            if (a.reportingYear !== b.reportingYear) {
              return a.reportingYear - b.reportingYear;
            } else {
              return a.reportingMonthNumeric - b.reportingMonthNumeric;
            }
          })}
        >
          <Tooltip formatter={(value) => new Intl.NumberFormat("en").format(value)} />
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={"xAxis"}>
            {/* <Label value={"XXX"} layout="horizontal" verticalAlign="top" align="center" height={25} position="insideBottom" offset={-50}/> */}
          </XAxis>
          <YAxis
            width={80}
            tickFormatter={(tick) => {
              return tick.toLocaleString();
            }}
          >
            <Label value={"kWh"} align="center" position="insideLeft" offset={-20} angle={-90} />
          </YAxis>
          <Tooltip />
          <Legend />
          <Bar
            dataKey="sgreccAvailableQuantity"
            name="Active SGREC"
            fill="#8884d8"
            tickFormatter={(tick) => {
              return tick.toLocaleString();
            }}
          />
          <Bar dataKey="retiredCnIForSGREC" name="Retired SGREC for C&I" fill="#82ca9d" />
          <Bar
            dataKey="retiredResidentialForSGREC"
            name="Retired SGREC for Residential"
            fill="green"
          />
          <Bar dataKey="adhocforSGREC" name="Ad-hoc SGREC" fill="blue" />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const getColumns = () => {
    switch (currentTabTitle) {
      case "Active CC":
        return energyTableView.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Active REC":
        return energyTableView.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      default:
        return null;
    }
  };

  const secondTab = [
    {
      key: 1,
      label: "CC Chart",
      children: (
        <div style={{ width: "70%", margin: "auto", marginTop: 35, marginBottom: 150 }}>
          <CCDashboard />
        </div>
      ),

      forcedRender: true,
    },
    {
      key: 2,
      label: "REC Chart",
      children: recDashboardData[0] != null && (
        <div style={{ width: "70%", margin: "auto", marginTop: 35, marginBottom: 150 }}>
          <RECDashboard />
        </div>
      ),
      forcedRender: true,
    },
    {
      key: 3,
      label: "SGREC Chart",
      children: sgrecDashboardData[0] != null && (
        <div style={{ width: "70%", margin: "auto", marginTop: 35, marginBottom: 150 }}>
          <SGRECDashboard />
        </div>
      ),

      forcedRender: true,
    },
  ];

  return (
    <div
      className="App"
      style={{ overflowX: "auto", width: "100%", margin: "auto", marginTop: 50, marginLeft: 50 }}
    >
      {loading === false && (
        <Tabs
          centered={true}
          defaultActiveKey="1"
          items={secondTab}
          onChange={handleTabChange}
          destroyInactiveTabPane={true}
        ></Tabs>
      )}

      {/* <TemplateTable defaultColumns={templateView} dummyData={ccData[0]} label={'CC'}></TemplateTable> */
      /*IMPLEMENTATION FOR TEMPLATE */}
    </div>
  );
}

export default Dashboard;
